import React from 'react';

const TransactionsV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5091 2.9762C10.3924 2.8082 10.201 2.70771 9.99644 2.70764C9.81734 2.70764 9.64835 2.78483 9.53062 2.91663L9.48277 2.9762L6.34117 7.49866L1.98081 4.93616C1.76247 4.80797 1.48817 4.82409 1.28648 4.97717C1.08471 5.13034 0.994997 5.39051 1.05992 5.63538L3.14292 13.4908C3.21557 13.7648 3.46398 13.9557 3.74742 13.9557H16.2455C16.5287 13.9555 16.7764 13.7647 16.849 13.4908L18.932 5.63538C18.9969 5.39051 18.9072 5.13035 18.7054 4.97717C18.5037 4.82428 18.2293 4.80788 18.0111 4.93616L13.6498 7.49866L10.5091 2.9762ZM6.20835 8.87073C6.48998 9.036 6.8511 8.95628 7.03746 8.68811L9.99546 4.42737L12.9544 8.68811C13.1408 8.95651 13.5028 9.03627 13.7845 8.87073L17.3343 6.78381L15.764 12.7057H4.22789L2.65757 6.78381L6.20835 8.87073ZM16.6635 17.2887V16.0387H3.33249V17.2887H16.6635Z",
      fill: "white"
    }
  )
);

export { TransactionsV2 };
//# sourceMappingURL=TransactionsV2.js.map
